/**
 * Portrait + background changer locale pack: pl
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover jest darmowy po zalogowaniu i dobrze sprawdza się przy portretach od głowy do ramion: zdjęcia LinkedIn, CV, awatary WeChat lub Instagram oraz przezroczyste mastery do kadrów w stylu dokumentów.",
      "Prześlij ostre JPG, PNG lub WebP do 15 MB. AI automatycznie wykrywa osobę. Przed pobraniem przybliż luźne włosy, okulary, kolczyki i linię kołnierzyka.",
      "Przezroczyste PNG to nie gotowe białe lub niebieskie zdjęcie do dokumentu. Najpierw zachowaj przezroczysty master, potem dodaj wymaganą barwę i przytnij do oficjalnego rozmiaru formularza."
    ],
    "practice": [
      "Zaczynam, gdy mogę, od oryginału z aparatu. Miniatury z czatów i mocne filtry beauty zmiękczają krawędzie włosów i utrudniają zachowanie zauszników okularów.",
      "Zawsze kładę wycięcie na jasne i ciemne płótno. Ten jeden check wychwytuje blade halo i brakujące pasma, które w miniaturze wyglądają dobrze."
    ],
    "compareIntro": "Użyj tego przewodnika do osób—awatarów, zdjęć w stylu dokumentów i profesjonalnych headshotów. Do białych teł produktów—przewodnik e-commerce; gdy po wycięciu chcesz scenę kawiarni lub biura—przewodnik zmiany tła.",
    "workflow": "Prześlij wyraźny portret do 15 MB, pozwól AI usunąć całe tło, sprawdź włosy i okulary, pobierz przezroczyste PNG, a dopiero potem dodaj biel, błękit lub kolor marki.",
    "scenarioIntro": "Wybierz zadanie portretowe najbliższe Twojemu i sprawdź krawędzie, które w tym przypadku najczęściej zawodzą.",
    "sec": {
      "tldrTitle": "Krótka wersja",
      "tldrCols": [
        "Czego potrzebujesz",
        "Szczegóły"
      ],
      "tldrRows": [
        [
          "Cena",
          "Miral AI Background Remover jest darmowy po zalogowaniu"
        ],
        [
          "Upload",
          "JPG, PNG lub WebP do 15 MB"
        ],
        [
          "Najlepsze do",
          "Headshotów LinkedIn, zdjęć do CV, awatarów, masterów dokumentów"
        ],
        [
          "Pobieranie",
          "Przezroczyste PNG; biel lub błękit dodaj później"
        ],
        [
          "Sprawdź dokładnie",
          "Włosy, okulary, kolczyki, kołnierzyk i ramiona"
        ],
        [
          "Nie ten artykuł",
          "Białe tła produktów marketplace należą do przewodnika e-commerce"
        ]
      ],
      "tldrP": "Selfie z ulicy lub pospieszne zdjęcie z biura nadal może stać się czystym headshotem w Miral AI. Wytnij osobę raz, zachowaj przezroczysty plik i dopiero potem zbuduj białą, niebieską lub markową wersję, której naprawdę potrzebujesz.",
      "whatTitle": "Czego potrzebują awatary, zdjęcia do dokumentów i headshoty LinkedIn",
      "whatP1": "Wszystkie trzy zadania mają ten sam pierwszy krok: wytnij osobę w Miral AI Background Remover i zachowaj czyste przezroczyste PNG. Różnica to kolor i kadrowanie dodane później.",
      "whatAvatarP": "Co rozwiązuje usuwanie tła awatara: selfie z sypialni i ujęcia z ulicy chowają twarz w bałaganie. Usuń tło, połóż wycięcie na kolorze marki lub jednolitym tonie, potem podejrzyj okrągły kadr na Instagram, WeChat lub stronę osobistą.",
      "galleryAvatarCaption": "Przykład awatara: po lewej zagracone selfie w pomieszczeniu; po prawej wycięcie na jednolitym kolorze gotowe do okrągłego profilu.",
      "whatIdP": "Co rozwiązuje usuwanie tła zdjęcia do dokumentu: wnioski często wymagają bieli lub błękitu. Zdjęcie z salonu zwykle nie przechodzi. Wytnij raz, dodaj wymagany kolor, przytnij do oficjalnego rozmiaru. Przed wysłaniem zawsze sprawdź aktualne reguły formularza.",
      "galleryIdCaption": "Przykład dokumentu: po lewej zajęte tło domowe; po prawej ta sama osoba na czystej bieli do przycięcia rozmiaru.",
      "whatLinkedInP": "Co rozwiązuje wycięcie headshota LinkedIn: open space ustawia za Tobą monitory i współpracowników. Spokojne szare lub białe tło wraca uwagę na twarz i ubiór—to pierwsze, co zauważa rekruter.",
      "galleryLinkedInCaption": "Przykład LinkedIn: po lewej zajęte selfie z biura; po prawej wycięcie na miękkiej szarości gotowe dla rekrutera.",
      "whatTipTitle": "Jeden przezroczysty master dla wszystkich trzech",
      "whatTipText": "Najpierw pobierz przezroczyste PNG. Awatar w kolorze marki, eksport biały/niebieski do dokumentu i miękkoszara karta LinkedIn pochodzą z tego samego pliku.",
      "howTitle": "Cztery kroki do użytecznego headshota",
      "howP": "Otwórz Miral AI Background Remover, prześlij zdjęcie od głowy do ramion, poczekaj na automatyczne wykrycie i przed pobraniem przybliż włosy i okulary do 100%. Biel lub błękit dodaj dopiero, gdy krawędź wygląda czysto.",
      "howTipTitle": "Preferuj plik oryginalny",
      "howTipText": "Mocne filtry beauty i kompresja komunikatorów rozmywają luźne włosy. Oryginał z aparatu prawie zawsze wygrywa.",
      "edgeTitle": "Gdzie portrety zwykle zawodzą",
      "edgeCols": [
        "Obszar",
        "Częsty błąd",
        "Jak sprawdzić"
      ],
      "edgeRows": [
        [
          "Luźne włosy",
          "Pasma usunięte jako tło",
          "Obejrzyj na ciemnym i jasnym płótnie"
        ],
        [
          "Okulary",
          "Brakujący zausznik lub dziura w szkle",
          "Przybliż narożniki oprawek"
        ],
        [
          "Kolczyki / cienkie łańcuszki",
          "Przerwane linie metalu",
          "Śledź krawędź biżuterii"
        ],
        [
          "Linia kołnierzyka i marynarki",
          "Białe halo lub poszarpane ramię",
          "Połóż na ciemnym płótnie"
        ],
        [
          "Broda lub bokobrody",
          "Zarost wygładzony",
          "Spróbuj ponownie z mniejszą retuszą źródła"
        ]
      ],
      "edgeP": "„Wygląda OK” w miniaturze nie wystarczy. Przegląd w pełnym rozmiarze na dwóch kolorach tła to najszybszy test uczciwości.",
      "useTitle": "Awatar, LinkedIn, CV i zdjęcia w stylu dokumentów",
      "useCols": [
        "Zastosowanie",
        "Typowe tło",
        "Notatka praktyczna"
      ],
      "useRows": [
        [
          "LinkedIn / portale pracy",
          "Miękka szarość, biel lub czyste rozmycie",
          "Utrzymaj ostrą twarz; spokojne tła wygrywają"
        ],
        [
          "Awatar WeChat / Instagram",
          "Kolor marki lub prosty gradient",
          "Podejrzyj okrągły kadr przed publikacją"
        ],
        [
          "Załącznik do CV",
          "Biel lub jasna szarość",
          "Zostaw miejsce nad głową i pod ramionami"
        ],
        [
          "Typowe wydruki w stylu dokumentów",
          "Biel lub błękit",
          "Dodaj wymagany kolor na przezroczystym PNG, potem przytnij"
        ],
        [
          "Zdjęcia paszportowe / wizowe",
          "Postępuj według aktualnych reguł oficjalnych",
          "Kolor, wyraz twarzy i okulary różnią się według kraju"
        ],
        [
          "Okładki kursów lub livestreamów",
          "Kolor marki lub późniejsza scena",
          "Najpierw czysto wytnij, potem projektuj okładkę"
        ]
      ],
      "useTipTitle": "Zasady się zmieniają",
      "useTipText": "Reguły zdjęć wizowych i egzaminacyjnych różnią się według kraju i roku. Narzędzie czyści obiekt; zgodność nadal pochodzi z oficjalnej checklisty.",
      "hairTitle": "Wycinanie włosów i okulary",
      "hairItems": [
        "Luźne włosy pod światło potrzebują prostszego, bardziej kontrastowego zdjęcia źródłowego.",
        "Przy okularach potwierdź, że oba zauszniki i obszar szkieł pozostają nienaruszone.",
        "Ciemne włosy na ciemnej ścianie to zły punkt startu—jeśli możesz, podejdź do jaśniejszej ściany.",
        "Jasny sweter na białej ścianie często traci krawędź ramienia; zmień tło zdjęcia.",
        "Długie loki i luźne włosy dzieci zasługują na obowiązkowy zoom 100% przed pobraniem."
      ],
      "hairP": "Duże kształty ubrań rzadko rujnują wycięcie portretu. Włosy i okulary—tak. Tam poświęcam dodatkową minutę.",
      "troubleTitle": "Gdy headshot wygląda źle",
      "troubleCols": [
        "Problem",
        "Prawdopodobna przyczyna",
        "Spróbuj tego"
      ],
      "troubleRows": [
        [
          "Brakujące fragmenty włosów",
          "Miękkie, skompresowane lub podświetlone źródło",
          "Użyj ostrzejszego oryginału z mniejszym beauty"
        ],
        [
          "Blada obwódka na twarzy lub ramionach",
          "Stary kolor tła przyklejony do krawędzi",
          "Potwierdź na ciemnym płótnie, potem spróbuj z większym kontrastem"
        ],
        [
          "Przerwane oprawki okularów",
          "Silne odbicia mylą kontur",
          "Powtórz zdjęcie z miększym światłem na szkłach"
        ],
        [
          "Ubranie zlewa się ze ścianą",
          "Niski kontrast obiekt/tło",
          "Zmień tło zamiast ponownie wysyłać ten sam plik"
        ],
        [
          "Zdjęcie do dokumentu wygląda żółto",
          "Ciepły balans bieli źródła",
          "Najpierw wytnij, potem zneutralizuj kolor na finalnym płótnie"
        ]
      ],
      "troubleTipTitle": "Zmień wejście",
      "troubleTipText": "Ponowne wysłanie tego samego miękkiego selfie rzadko naprawia włosy. Czystsze źródło zwykle tak.",
      "prosConsTitle": "Gdzie pomaga—i gdzie wciąż decydujesz",
      "bestTitle": "Nawyki, które czynią awatary użytecznymi",
      "bestItems": [
        "Używaj kadru od głowy do ramion z odrobiną miejsca nad włosami.",
        "Zachowaj naturalny wyraz; unikaj mocnego wygładzania skóry przed wycięciem.",
        "Za każdym razem sprawdzaj PNG na jasnym i ciemnym płótnie.",
        "Przechowuj przezroczysty master, kolorowy eksport do dokumentu i finalny kadr jako osobne pliki.",
        "Na platformach pracy spokojne tło czyni twarz i ubiór czytelniejszymi.",
        "Jeśli potrzebujesz klimatu kawiarni lub biura, najpierw czysto wytnij, potem idź do przewodnika zmiany tła."
      ],
      "miralTitle": "Co robić po wycięciu",
      "miralP": "W Miral AI możesz wyostrzyć portret, zbudować spokojną kartę awatara lub przejść do Seedream albo FLUX.2 po scenę okładkową. Do lifestyle’owej wymiany tła otwórz przewodnik wymiany tła AI. Do bieli listingów produktowych użyj przewodnika e-commerce.",
      "miralLinksTitle": "Kolejne kroki",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Przewodnik zmiany tła AI",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "Ogólny przewodnik usuwania tła AI",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Przewodnik tła produktu e-commerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ],
      "intentsTitle": "Częste workflow portretowe",
      "faqTitle": "Pytania przed uploadem",
      "faqItems": [
        [
          "Jak usunąć tło portretu online za darmo?",
          "Zaloguj się do Miral AI, prześlij JPG, PNG lub WebP od głowy do ramion i pobierz przezroczyste PNG."
        ],
        [
          "Jak zrobić białe lub niebieskie zdjęcie do dokumentu z selfie?",
          "Najpierw wyeksportuj przezroczyste PNG, dodaj wymaganą biel lub błękit, przytnij do oficjalnego rozmiaru i sprawdź aktualne reguły przed wysłaniem."
        ],
        [
          "Jak zrobić headshot LinkedIn z usuwaniem tła?",
          "Usuń zajęte tło biurowe, połóż wycięcie na miękkiej szarości lub bieli i przed uploadem potwierdź krawędzie włosów i ramion."
        ],
        [
          "Czy mogę za darmo usunąć tło awatara WeChat lub Instagram?",
          "Tak. Zaloguj się, przetwórz oryginał awatara i podejrzyj okrągły kadr na kolorze marki."
        ],
        [
          "Czy da się wyciąć online zdjęcie w okularach?",
          "Tak, ale przed pobraniem przybliż oprawki, zauszniki i obszar szkieł."
        ],
        [
          "Jakiego narzędzia użyć do wycinania włosów na portretach?",
          "Użyj Miral AI Background Remover z oryginałem z aparatu i sprawdź luźne włosy na jasnym i ciemnym płótnie."
        ],
        [
          "Jakiego narzędzia użyć do przygotowania tła zdjęcia paszportowego?",
          "Najpierw zrób przezroczysty master portretu, potem wyeksportuj oficjalny kolor tła i rozmiar w milimetrach."
        ],
        [
          "Jak naprawić białe halo po usunięciu tła portretu?",
          "Połóż przezroczyste PNG na ciemnym płótnie, znajdź obwódkę i spróbuj ponownie z ostrzejszym, bardziej kontrastowym oryginałem."
        ],
        [
          "Jak naprawić brakujące luźne włosy przy lokach lub zdjęciach dzieci?",
          "Unikaj mocnego beauty i miniatur z czatu. Użyj wyraźniejszego oryginału i przed pobraniem sprawdź przy 100%."
        ],
        [
          "Czy mogę hurtowo przetworzyć wiele profesjonalnych headshotów?",
          "Obecna strona przetwarza jeden obraz naraz, aby każdą krawędź włosów dało się sprawdzić."
        ],
        [
          "Jaka jest różnica między przezroczystym a białym tłem dokumentu?",
          "Przezroczyste PNG może później przyjąć dowolny kolor. Biały eksport do dokumentu już zawiera białe piksele do formularzy i CV."
        ],
        [
          "Jak potem zmienić tło na scenę kawiarni lub biura?",
          "Gdy przezroczyste PNG przejdzie przegląd, postępuj według przewodnika wymiana tła AI i sprawdź dopasowanie światła."
        ]
      ]
    },
    "linksTitle": "Kontynuuj w Miral AI",
    "linksIntro": "Zachowaj przezroczysty master portretu, potem wyostrz, zbuduj kartę awatara lub przejdź do sceny życia codziennego.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Przewodnik zmiany tła AI",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "Ogólny przewodnik usuwania tła AI",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Przewodnik tła produktu e-commerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Wybierz wyraźne zdjęcie od głowy do ramion",
        "text": "Użyj JPG, PNG lub WebP do 15 MB z w pełni widoczną twarzą i ramionami."
      },
      {
        "title": "Usuń tło automatycznie",
        "text": "Miral AI Background Remover wykrywa osobę i czyści całe tło—bez ręcznego konturu."
      },
      {
        "title": "Sprawdź włosy i okulary",
        "text": "Przybliż luźne włosy, oprawki, kolczyki i linię kołnierzyka."
      },
      {
        "title": "Pobierz przezroczyste PNG, potem dodaj kolor",
        "text": "Zachowaj master, potem dodaj biel, błękit, szarość lub kolor marki do finalnego użycia."
      }
    ],
    "pros": [
      "Zbudowany pod krawędzie portretów do awatarów i zdjęć w stylu dokumentów",
      "Bez narzędzia pióra Photoshopa do włosów",
      "Jedno przezroczyste PNG może stać się wieloma kolorami tła",
      "Darmowe przetwarzanie w przeglądarce po zalogowaniu"
    ],
    "cons": [
      "Cienkie włosy nadal wymagają sprawdzenia w pełnym rozmiarze",
      "Podświetlenie lub niski kontrast może zmiękczyć krawędzie",
      "Na obecnej stronie jeden obraz naraz",
      "Oficjalne reguły dokumentów nadal wymagają ręcznej kontroli zgodności"
    ],
    "tips": [
      {
        "title": "Sprawdź dwa kolory płótna",
        "text": "Jasne i ciemne tła szybko ujawniają halo i brakujące pasma."
      },
      {
        "title": "Chroń okulary i biżuterię",
        "text": "Przed pobraniem przybliż zauszniki, narożniki szkieł i cienkie łańcuszki."
      },
      {
        "title": "Rozdziel master i eksport do dokumentu",
        "text": "Nie nadpisuj przezroczystego PNG spłaszczonym plikiem białym lub niebieskim."
      },
      {
        "title": "Trzymaj filtry lekko",
        "text": "Mocne beauty zmiękcza dokładnie te krawędzie, których model potrzebuje."
      },
      {
        "title": "Wiedz, który przewodnik otworzyć dalej",
        "text": "Zamiana sceny → wymiana tła. Biel produktów → przewodnik e-commerce."
      }
    ],
    "scenarios": [
      {
        "title": "Usuwanie tła headshota LinkedIn",
        "text": "Wytnij ostre zdjęcie od głowy do ramion i przed uploadem połóż na miękkiej szarości lub bieli."
      },
      {
        "title": "Wycięcie awatara WeChat lub Instagram",
        "text": "Pobierz przezroczyste PNG i podejrzyj okrągły kadr na kolorze marki."
      },
      {
        "title": "Zdjęcie do CV na białym tle",
        "text": "Zachowaj przezroczysty master, potem wyeksportuj osobny plik z białym tłem do PDF."
      },
      {
        "title": "Zdjęcie w stylu dokumentu na niebieskim tle",
        "text": "Dodaj wymagany błękit dopiero, gdy krawędź włosów wygląda czysto."
      },
      {
        "title": "Usuwanie tła wokół włosów online",
        "text": "Użyj oryginału z aparatu i sprawdź luźne włosy na jasnym i ciemnym płótnie."
      },
      {
        "title": "Wycięcie portretu w okularach",
        "text": "Przybliż narożniki oprawek i zauszniki, zanim zaufasz pobraniu."
      },
      {
        "title": "Przygotowanie zdjęcia paszportowego",
        "text": "Najpierw zrób przezroczyste PNG, potem stosuj aktualne reguły rozmiaru i koloru kraju."
      },
      {
        "title": "Selfie z biura do profesjonalnego headshota",
        "text": "Usuń bałagan z korytarza, zachowaj naturalny wyraz, unikaj mocnych filtrów."
      },
      {
        "title": "Wycięcie dzieci lub loków",
        "text": "Spodziewaj się więcej luźnych włosów; zawsze sprawdzaj przy zoomie 100%."
      },
      {
        "title": "Przezroczyste vs białe tło portretu",
        "text": "Przezroczyste pozostaje wielokrotnego użytku; biel to spłaszczony eksport pod konkretny formularz."
      },
      {
        "title": "Naprawa białego halo na wycięciu twarzy",
        "text": "Potwierdź obwódkę na ciemnym płótnie, potem spróbuj z silniejszym kontrastem źródła."
      },
      {
        "title": "Od wycięcia portretu do sceny kawiarni",
        "text": "Użyj przewodnika zmiany tła, gdy przezroczyste PNG przejdzie przegląd."
      }
    ],
    "toolFaq": [
      {
        "q": "Jak usunąć tło portretu online za darmo?",
        "a": "Zaloguj się, prześlij portret i pobierz przezroczyste PNG bez oprogramowania desktopowego."
      },
      {
        "q": "Jak zrobić białe lub niebieskie zdjęcie do dokumentu z selfie?",
        "a": "Usuń tło, zachowaj przezroczyste PNG, dodaj wymagany kolor i przytnij do oficjalnego rozmiaru."
      },
      {
        "q": "Czy mogę za darmo usunąć tło awatara WeChat lub Instagram?",
        "a": "Tak. Po zalogowaniu przetwórz oryginał awatara i podejrzyj okrągły kadr na kolorze marki."
      },
      {
        "q": "Czy da się wyciąć online zdjęcie w okularach?",
        "a": "Tak, ale przed pobraniem sprawdź zauszniki i obszary szkieł w pełnym rozmiarze."
      },
      {
        "q": "Jakiego narzędzia użyć do wycinania włosów na portretach?",
        "a": "Użyj Miral AI Background Remover z ostrym oryginałem i sprawdź luźne włosy na jasnym i ciemnym płótnie."
      },
      {
        "q": "Jakiego narzędzia użyć do przygotowania tła zdjęcia paszportowego?",
        "a": "Najpierw utwórz przezroczysty master portretu, potem wyeksportuj oficjalny kolor i rozmiar wymagany przez formularz."
      },
      {
        "q": "Jak naprawić białe halo po usunięciu tła portretu?",
        "a": "Potwierdź obwódkę na ciemnym płótnie, potem spróbuj z ostrzejszym, bardziej kontrastowym źródłem."
      },
      {
        "q": "Jak naprawić brakujące luźne włosy przy lokach lub zdjęciach dzieci?",
        "a": "Unikaj mocnego beauty i miniatur z czatu; użyj wyraźniejszego oryginału i sprawdź przy 100%."
      },
      {
        "q": "Czy mogę hurtowo przetworzyć wiele profesjonalnych headshotów?",
        "a": "Obecna strona obsługuje jeden obraz naraz."
      },
      {
        "q": "Jak potem zmienić tło na scenę kawiarni?",
        "a": "Użyj sprawdzonego przezroczystego PNG w workflow wymiany tła AI."
      }
    ]
  },
  "changer": {
    "overview": [
      "Zmiana tła działa najlepiej w dwóch krokach: darmowe usunięcie tła do czystego przezroczystego PNG, potem umieszczenie w nowej scenie—światło kawiarni, spokojne biuro, ściana marki lub światło dzienne na zewnątrz.",
      "Miral AI Background Remover zajmuje się wycięciem. Seedream lub FLUX.2 mogą potem budować sceny życia codziennego. Nie myl tego z czysto białymi płytami produktów w stylu Amazon; ten workflow jest w przewodniku e-commerce.",
      "Jeśli wycięcie nadal ma bladą obwódkę, każda nowa scena będzie wyglądać sztucznie. Najpierw napraw krawędzie, potem myśl o atmosferze."
    ],
    "practice": [
      "Nie komponuję, dopóki przezroczysty obiekt nie wygląda czysto na jasnym i ciemnym płótnie.",
      "Dopasowuję kierunek światła, zanim dopasuję „ładność”. Portret przy oknie na neonowej ulicy nocą rzadko kogokolwiek nabiera."
    ],
    "compareIntro": "Usuwanie tła do przezroczystego mastera, ten przewodnik do scen lifestyle lub okładek, przewodnik portretowy do kolorów w stylu dokumentów i przewodnik e-commerce do białych teł marketplace.",
    "workflow": "Wytnij obiekt, wybierz scenę pasującą do oświetlenia, skomponuj lub wygeneruj nowe otoczenie, potem przed eksportem sprawdź cienie kontaktu, temperaturę barwową i krawędzie.",
    "scenarioIntro": "Najpierw ustal cel sceny, potem trzymaj przezroczysty master osobno od każdego gotowego kadru.",
    "sec": {
      "tldrTitle": "Kolejność, która naprawdę działa",
      "tldrCols": [
        "Krok",
        "Zachowaj",
        "Uwaga"
      ],
      "tldrRows": [
        [
          "1. Usuń tło",
          "Przezroczysty master PNG Miral AI",
          "Stare halo rujnują każdą późniejszą scenę"
        ],
        [
          "2. Wybierz scenę",
          "Kawiarnia, biuro, ściana marki, outdoor",
          "Wybieraj pod zadanie, nie pod losową estetykę"
        ],
        [
          "3. Komponuj lub generuj",
          "Obraz lifestyle lub okładka",
          "Dopasuj kierunek światła i temperaturę barwową"
        ],
        [
          "4. Przejrzyj",
          "Eksport gotowy do publikacji",
          "Krawędzie, skala i poczucie kontaktu"
        ],
        [
          "Oddziel od białych płyt",
          "Przewodnik e-commerce dla białych SKU",
          "Ten artykuł jest o zamianie sceny"
        ]
      ],
      "tldrP": "Zmiana tła to nie jeden magiczny filtr. W Miral AI izolujesz obiekt Background Removerem, a potem dajesz mu nowe miejsce. Pomiń pierwszą pracę, a druga prawie zawsze wygląda jak wklejka.",
      "removeTitle": "Obrazy lifestyle, okładki społecznościowe i plakaty eventowe potrzebują różnych płyt",
      "removeP1": "Stare kolory ścian przyklejają się do krawędzi włosów i kurtki. Stabilna ścieżka jest ta sama: Miral AI Background Remover → przezroczysty master PNG → nowa scena pod zadanie. Białe płyty produktów marketplace należą do przewodnika e-commerce, nie tutaj.",
      "removeLifestyleP": "Co rozwiązuje zmiana tła lifestyle: światło kawiarni, miejsca przy oknie i domowe kąty budują atmosferę—ale bałaganiarskie oryginalne tło czyni całą klatkę tanią. Wytnij czysto, potem umieść osobę w scenie, której światło pasuje do twarzy.",
      "galleryLifestyleCaption": "Przykład lifestyle: po lewej przezroczysty master; po prawej ta sama osoba skomponowana w jasną scenę kawiarni.",
      "removeSocialP": "Co rozwiązuje zmiana tła okładki społecznościowej: nagłówki Instagram, Xiaohongshu i LinkedIn potrzebują wyraźnej twarzy i miejsca na tytuł. Zagracona sypialnia lub open space wypełnia kadr. Gradient marki lub spokojna kolorowa ściana stawia osobę z jednej strony i zostawia drugą na copy.",
      "gallerySocialCaption": "Przykład okładki społecznościowej: po lewej przezroczysty master; po prawej ściana z gradientem marki z miejscem na nagłówek.",
      "removePosterP": "Co rozwiązuje zmiana tła plakatu eventowego: webinary, starty kursów i ogłoszenia talków potrzebują spokojnej sceny lub ściany marki—nie selfie przy biurku. Po wycięciu umieść osobę na miękkiej płycie marki z wolnym miejscem na tytuł, a w razie potrzeby dodaj tekst w GPT Image.",
      "galleryPosterCaption": "Przykład plakatu eventowego: po lewej przezroczysty master; po prawej miękka ściana marki pod okładkę talku lub kursu.",
      "removeTipTitle": "Trzymaj osobno master, scenę i kadry okładki",
      "removeTipText": "Nie nadpisuj przezroczystego PNG jednym eksportem kawiarni lub gradientu. Plakat następnego sezonu powinien ponownie użyć tego samego wycięcia.",
      "howTitle": "Praktyczny workflow online",
      "howP": "Najpierw otwórz Miral AI Background Remover i uzyskaj wiarygodny przezroczysty obiekt. Potem wybierz typ tła: jednolity kolor jest najszybszy, prawdziwa płyta zdjęciowa następna, a środowisko wygenerowane przez AI najelastyczniejsze. Przed eksportem sprawdź, czy osoba nadal wygląda jak oświetlona tym samym światem co tło.",
      "howTipTitle": "Światło wygrywa z dekoracją",
      "howTipText": "Spokojniejsze tło z pasującym światłem wygrywa z dramatyczną sceną, która walczy z twarzą.",
      "sceneTitle": "Pomysły na sceny, które zwykle klikają",
      "sceneCols": [
        "Kierunek",
        "Dobre do",
        "Uwaga"
      ],
      "sceneRows": [
        [
          "Jasna kawiarnia / miejsce przy oknie",
          "Marka osobista i okładki lifestyle",
          "Ciepłe żarówki mogą spychać skórę w zbyt pomarańczowy"
        ],
        [
          "Spokojne biuro / miękkie rozmycie regału",
          "LinkedIn i wizerunki mentora kursu",
          "Rekwizyty tła powinny być cichsze niż twarz"
        ],
        [
          "Światło dzienne na zewnątrz i zieleń",
          "Posty podróżnicze, wellness, lifestyle",
          "Unikaj twardego światła południowego walczącego z oryginałem"
        ],
        [
          "Jednolita lub miękka ściana gradientu marki",
          "Plakaty eventowe i nagłówki społecznościowe",
          "Utrzymaj kontrast wystarczający do tekstu nakładkowego"
        ],
        [
          "Oświetlenie sceniczne lub keynote",
          "Ogłoszenia talków",
          "Flary nie powinny przecinać twarzy"
        ],
        [
          "Domowy kąt lifestyle",
          "Miękkie storytelling produktów",
          "Utrzymaj perspektywę i skalę osoby spójne"
        ]
      ],
      "sceneP": "Warte kliknięcia często znaczy wyraźne, nie zatłoczone. Czysta osoba na spokojnym, zamierzonym tle zwykle wygrywa z zajętym kolażem.",
      "qualityTitle": "Pięć miejsc, gdzie widać fałsz",
      "qualityItems": [
        "Włosy i ramiona: pozostałe białe lub kolorowe frędzle ze starego pokoju.",
        "Kierunek światła: highlight twarzy i światło z okna powinny się zgadzać.",
        "Temperatura barwowa: ciepła skóra wnętrza na zimnej niebieskiej płycie wygląda jak rozszczepienie.",
        "Skala: osoba nie powinna unosić się jak naklejka ani kurczyć w złą głębię.",
        "Kontakt: ślad kontaktu z podłogą lub krzesłem czyni kompozycję wiarygodną."
      ],
      "qualityTipTitle": "Wcześnie podejrzyj kadr",
      "qualityTipText": "Sprawdź kwadratowy kadr awatara i szeroki kadr okładki, zanim zatwierdzisz finalną scenę.",
      "vsTitle": "Jak ten artykuł oddziela się od innych",
      "vsCols": [
        "Przewodnik",
        "Główne zadanie",
        "Otwórz gdy"
      ],
      "vsRows": [
        [
          "Ogólny AI background remover",
          "Dowolny obiekt → przezroczyste PNG",
          "Potrzebujesz tylko wycięcia"
        ],
        [
          "Tło produktu e-commerce",
          "Białe / przezroczyste płyty produktów",
          "Zgodność listingów Amazon, Shopify"
        ],
        [
          "Usuwanie tła portretu",
          "Awatary i kolory w stylu dokumentów",
          "Twarze, włosy, białe/niebieskie mastery dokumentów"
        ],
        [
          "Wymiana tła AI (ten)",
          "Zamiana sceny po wycięciu",
          "Atmosfera kawiarni, biura, ściany marki"
        ]
      ],
      "vsP": "Linkuj cztery przewodniki, ale utrzymuj słowa kluczowe uczciwie. Białe płyty produktów nie należą do artykułu o scenach życia codziennego, a niebieskie zdjęcia wizowe nie należą do pitchu kompozycji kawiarni.",
      "troubleTitle": "Gdy nowa scena wygląda źle",
      "troubleCols": [
        "Problem",
        "Przyczyna",
        "Naprawa"
      ],
      "troubleRows": [
        [
          "Jasna frędzla wokół obiektu",
          "Wycięcie nadal brudne",
          "Wróć do usuwania z bardziej kontrastowym oryginałem"
        ],
        [
          "Wygląda jak naklejka",
          "Brak kontaktu lub niedopasowane światło",
          "Zmiękcz płytę lub dodaj bardzo lekki cień kontaktu"
        ],
        [
          "Skóra staje się szara lub pomarańczowa",
          "Konflikt temperatury barwowej",
          "Wybierz scenę bliższej temperatury lub ujednolić grade"
        ],
        [
          "Włosy wyglądają brudno",
          "Niepełna alfa wokół pasm",
          "Wyczyść wycięcie przed ponowną kompozycją"
        ],
        [
          "Kształt produktu dryfuje w scenie AI",
          "Generacja zmieniła obiekt",
          "Zablokuj tożsamość; niech AI wymyśli tylko otoczenie"
        ]
      ],
      "prosConsTitle": "Co ten workflow odblokowuje",
      "bestTitle": "Zamiany, które trzymają się na ekranie telefonu",
      "bestItems": [
        "Nigdy nie pomijaj czystego przezroczystego mastera.",
        "Kanał decyduje o scenie: rekrutacja zostaje spokojna, lifestyle może oddychać, plakaty potrzebują miejsca na tytuł.",
        "Proste oświetlenie źródła ułatwia zamianę.",
        "Zawsze podejrzyj w rozmiarze telefonu przed publikacją.",
        "Dodaj tekst nagłówka dopiero, gdy scena działa—GPT Image pomaga z typografią plakatów.",
        "Wyślij białe SKU marketplace do przewodnika e-commerce, aby intencje pozostały rozdzielone."
      ],
      "miralTitle": "Utrzymaj łańcuch w Miral AI",
      "miralP": "Sugerowana ścieżka w Miral AI: Background Remover → opcjonalny Image Enhancer → Seedream lub FLUX.2 dla otoczenia → GPT Image, jeśli potrzebujesz typografii plakatu. Do białych lub niebieskich kart w stylu dokumentów wróć do przewodnika portretowego.",
      "miralLinksTitle": "Kolejne kroki",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Przewodnik portretów i dokumentów",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "Ogólny przewodnik usuwania tła AI",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Przewodnik tła produktu e-commerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ],
      "intentsTitle": "Częste zadania zmiany tła",
      "faqTitle": "Pytania praktyczne",
      "faqItems": [
        [
          "Jak zmienić tło zdjęcia online za darmo?",
          "Zaloguj się do Miral AI, wyeksportuj przezroczyste PNG w Background Remover i umieść obiekt na kawiarni, ścianie marki lub nowej scenie."
        ],
        [
          "Jak zrobić obraz życia codziennego z przezroczystego PNG?",
          "Skomponuj na płycie z pasującym światłem, sprawdź kontakt i temperaturę barwową oraz trzymaj master i kadry okładki osobno."
        ],
        [
          "Jak zmienić tło okładki społecznościowej po wycięciu?",
          "Gdy krawędzie włosów przejdą przegląd, umieść obiekt po jednej stronie gradientu marki i zostaw miejsce na tytuł."
        ],
        [
          "Czy mogę zamienić tło selfie na scenę kawiarni?",
          "Tak. Najpierw czysto wytnij, potem skomponuj na płycie kawiarni, której światło z okna pasuje do twarzy."
        ],
        [
          "Czy da się wygenerować nową scenę AI za prawdziwą osobą?",
          "Tak. Zachowaj prawdziwy obiekt z przezroczystego PNG i pozwól Seedream lub FLUX.2 wymyślić tylko otoczenie."
        ],
        [
          "Jakiego narzędzia użyć do zamiany tła plakatu eventowego?",
          "Użyj Miral AI Background Remover do wycięcia, połóż na miękkiej ścianie marki i w razie potrzeby dodaj typografię nagłówka w GPT Image."
        ],
        [
          "Jakiego narzędzia użyć do zamiany tła okładki społecznościowej?",
          "Background Remover plus ściana w kolorze marki lub gradient. Kontynuuj w Seedream lub FLUX.2, gdy potrzebujesz pełniejszej sceny życia codziennego."
        ],
        [
          "Jak naprawić kompozycję tła wyglądającą sztucznie?",
          "Sprawdź frędzle, kierunek światła i temperaturę barwową w tej kolejności. Jeśli krawędzie są brudne, najpierw wróć do usuwania tła."
        ],
        [
          "Jak naprawić niedopasowanie światła dziennego na zewnątrz przy zmianie tła?",
          "Dopasuj kierunek słońca; unikaj twardego światła południowego na twarzy oświetlonej pod wnętrze."
        ],
        [
          "Czy mogę użyć zmiany tła do okładki wideo?",
          "Tak. Wyeksportuj kadr w proporcji okładki i trzymaj obiekt w bezpiecznym obszarze."
        ],
        [
          "Jaka jest różnica między usuwaniem a zmianą tła?",
          "Usuwanie daje przezroczysty obiekt. Zmiana umieszcza ten obiekt w nowej scenie lub kolorze."
        ],
        [
          "Czy mogę użyć tego do białych teł produktów Amazon?",
          "Nie. Białe płyty marketplace należą do przewodnika e-commerce; ten artykuł jest o scenach życia codziennego i okładkach."
        ]
      ]
    },
    "linksTitle": "Zbuduj workflow sceny w Miral AI",
    "linksIntro": "Wytnij raz, zachowaj przezroczysty master, potem twórz sceny życia codziennego, okładki lub płyty plakatów bez ponownego maskowania.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Przewodnik portretów i dokumentów",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "Ogólny przewodnik usuwania tła AI",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Przewodnik tła produktu e-commerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Najpierw wytnij czysty obiekt",
        "text": "Użyj Miral AI Background Remover, aby pobrać przezroczyste PNG i potwierdzić krawędzie włosów lub produktu."
      },
      {
        "title": "Ustal klimat nowej sceny",
        "text": "Kawiarnia, spokojne biuro, światło dzienne na zewnątrz lub ściana marki—wybierz pod kanał."
      },
      {
        "title": "Umieść obiekt na nowym tle",
        "text": "Skomponuj na płótnie projektowym lub kontynuuj w Seedream / FLUX.2 z pasującym światłem."
      },
      {
        "title": "Sprawdź światło, skalę i kontakt",
        "text": "Szukaj frędzli, konfliktu kolorów, złego rozmiaru i braku kontaktu."
      },
      {
        "title": "Wyeksportuj potrzebny kadr",
        "text": "Zapisz rozmiary okładki i awatara osobno i zostaw przezroczysty master nietknięty."
      }
    ],
    "pros": [
      "Jeden przezroczysty master obsługuje wiele scen",
      "Taniej niż ponowne fotografowanie każdego otoczenia",
      "Silne dopasowanie do okładek społecznościowych i kadrów lifestyle",
      "Czysto łączy się z pracą sceniczną Seedream i FLUX.2"
    ],
    "cons": [
      "Niedopasowane światło od razu wygląda sztucznie",
      "Brudne krawędzie wycięcia psują całą kompozycję",
      "Białe SKU marketplace powinny używać przewodnika e-commerce",
      "Złożone sceny perspektywiczne mogą nadal wymagać ręcznej polerki"
    ],
    "tips": [
      {
        "title": "Krawędzie przed atmosferą",
        "text": "Nigdy nie komponuj wycięcia, które nadal pokazuje halo na ciemnym płótnie."
      },
      {
        "title": "Najpierw dopasuj światło",
        "text": "Wybieraj płyty, których główne światło zgadza się z twarzą lub produktem."
      },
      {
        "title": "Trzymaj mastery osobno",
        "text": "Przezroczyste PNG, eksport lifestyle i kadry społecznościowe powinny być różnymi plikami."
      },
      {
        "title": "Zostaw miejsce na tekst",
        "text": "Tła plakatów potrzebują spokojniejszych stref, gdzie może usiąść nagłówek."
      },
      {
        "title": "Rozdziel intencje wyszukiwania",
        "text": "Wyślij białe płyty Amazon do artykułu e-commerce; ten zostaw na zmianę sceny."
      }
    ],
    "scenarios": [
      {
        "title": "Darmowa zamiana tła zdjęcia online",
        "text": "Najpierw wytnij obiekt, potem umieść na nowej płycie lub wygenerowanej scenie."
      },
      {
        "title": "Lifestyle’owe tło kawiarni do portretu",
        "text": "Użyj płyty ze światłem z okna pasującym do oświetlenia twarzy."
      },
      {
        "title": "Tło biurowe do zdjęcia profesjonalnego",
        "text": "Trzymaj półki i rekwizyty miększe niż osoba."
      },
      {
        "title": "Tło w kolorze marki do okładki społecznościowej",
        "text": "Przezroczyste PNG na jednolitym lub miękkim gradiencie z miejscem na tytuł."
      },
      {
        "title": "Zmiana tła po wycięciu AI",
        "text": "Nie komponuj, dopóki krawędzie włosów i kurtki nie przejdą testu dwóch płócien."
      },
      {
        "title": "Scena AI za prawdziwą osobą",
        "text": "Niech Seedream lub FLUX.2 wymyśli pokój, nie nową twarz ani strój."
      },
      {
        "title": "Zamiana tła plakatu eventowego",
        "text": "Preferuj czyste ściany marki, aby typografia nagłówka pozostała czytelna."
      },
      {
        "title": "Zamiana tła w świetle dziennym na zewnątrz",
        "text": "Dopasuj kierunek słońca; unikaj światła południowego na miękkiej twarzy z wnętrza."
      },
      {
        "title": "Naprawa sztucznie wyglądającej kompozycji tła",
        "text": "Sprawdź frędzle, kierunek światła i temperaturę barwową w tej kolejności."
      },
      {
        "title": "Od przezroczystego PNG do obrazu lifestyle",
        "text": "Zarchiwizuj master, eksportuj kadry okładki osobno."
      },
      {
        "title": "Nie do białych teł Amazon",
        "text": "Wyślij płyty listingów do przewodnika produktu e-commerce."
      },
      {
        "title": "Wycięcie portretu, potem zmiana sceny",
        "text": "Dokończ przegląd włosów w workflow portretowym, potem otwórz ten workflow sceny."
      }
    ],
    "toolFaq": [
      {
        "q": "Jak zmienić tło zdjęcia online za darmo?",
        "a": "Zaloguj się, usuń oryginalne tło do przezroczystego PNG, potem umieść obiekt na nowej scenie lub jednolitym kolorze."
      },
      {
        "q": "Jak zrobić obraz życia codziennego z przezroczystego PNG?",
        "a": "Skomponuj na płycie z pasującym światłem, sprawdź kontakt i temperaturę barwową oraz oddziel master od kadrów okładki."
      },
      {
        "q": "Czy mogę zamienić tło selfie na scenę kawiarni?",
        "a": "Tak. Najpierw wytnij osobę, potem skomponuj na płycie kawiarni z podobnym światłem z okna."
      },
      {
        "q": "Czy da się wygenerować nową scenę AI za prawdziwą osobą?",
        "a": "Tak. Zachowaj prawdziwy obiekt i pozwól Seedream lub FLUX.2 stworzyć tylko otoczenie."
      },
      {
        "q": "Jakiego narzędzia użyć do zamiany tła plakatu eventowego?",
        "a": "Użyj Background Remover do wycięcia, połóż na spokojnej ścianie marki i w razie potrzeby dodaj typografię nagłówka."
      },
      {
        "q": "Jakiego narzędzia użyć do zamiany tła okładki społecznościowej?",
        "a": "Background Remover plus ściana w kolorze marki lub gradient; kontynuuj w Seedream lub FLUX.2 dla pełniejszych scen lifestyle."
      },
      {
        "q": "Jak naprawić kompozycję tła wyglądającą sztucznie?",
        "a": "Wyczyść frędzle, dopasuj kierunek światła i ujednolić temperaturę barwową przed eksportem."
      },
      {
        "q": "Jak naprawić niedopasowanie światła dziennego na zewnątrz przy zmianie tła?",
        "a": "Dopasuj kierunek słońca i unikaj światła południowego na twarzy oświetlonej pod wnętrze."
      },
      {
        "q": "Czy mogę użyć zmiany tła do okładki wideo?",
        "a": "Tak. Wyeksportuj kadr w proporcji okładki i trzymaj obiekt w bezpiecznym obszarze."
      },
      {
        "q": "Czy mogę użyć tego do białych teł produktów Amazon?",
        "a": "Nie. Do białych płyt marketplace użyj przewodnika tła produktu e-commerce."
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "Darmowe usuwanie tła portretu AI: headshoty, awatary i zdjęcia do dokumentów",
      "excerpt": "Zamień zagracone selfie w czysty headshot: usuń tło portretu za darmo, wyeksportuj przezroczyste PNG, potem dodaj biel, błękit lub kolor marki do LinkedIn, CV i awatarów.",
      "metaTitle": "Darmowe usuwanie tła portretu AI | Miral",
      "metaDescription": "Usuwaj tła portretów za darmo z Miral AI. Zachowaj detale włosów, eksportuj przezroczyste wycięcia PNG i buduj headshoty LinkedIn lub białe i niebieskie zdjęcia w stylu dokumentów.",
      "target": {
        "label": "Otwórz usuwanie tła portretu",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "darmowe usuwanie tła portretu",
        "AI usuwanie tła headshot",
        "usuwanie tła zdjęcia LinkedIn",
        "usuwanie tła zdjęcia do dokumentu",
        "usuwanie tła awatara",
        "usuwanie tła wokół włosów",
        "zdjęcie CV białe tło",
        "niebieskie zdjęcie do dokumentu online"
      ]
    },
    "ai-background-changer-online": {
      "title": "Darmowa wymiana tła AI: sceny życia codziennego, okładki społecznościowe i plakaty eventowe",
      "excerpt": "Usuń stare tło za darmo, potem umieść osoby w scenach kawiarni, okładkach z gradientem marki lub ścianach plakatów eventowych—bez konkurowania z intencją białego tła e-commerce.",
      "metaTitle": "Darmowa wymiana tła AI online | Miral",
      "metaDescription": "Zmieniaj tła zdjęć online z Miral AI: wytnij do przezroczystego PNG, potem buduj kawiarniane sceny życia codziennego, okładki społecznościowe i sceny plakatów eventowych.",
      "target": {
        "label": "Otwórz AI Background Remover",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "darmowa wymiana tła AI",
        "zamiana tła zdjęcia online",
        "zmiana tła po wycięciu",
        "zamiana sceny AI",
        "wymiana tła scen życia codziennego",
        "tło kawiarni do portretu",
        "zamiana tła okładki społecznościowej",
        "przezroczyste PNG nowe tło"
      ]
    }
  }
}
